module.exports = __webpack_public_path__ + "static/media/mobile-right-intro.a1e31599.svg";